import { render, staticRenderFns } from "./YearDetail.vue?vue&type=template&id=4d17c39c&"
import script from "./YearDetail.vue?vue&type=script&lang=js&"
export * from "./YearDetail.vue?vue&type=script&lang=js&"
import style0 from "./YearDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VCard,VCardText,VMain})
